// extracted by mini-css-extract-plugin
var _1 = "TabList-moduleTabList__ioZlK";
export { _1 as "TabList" }
